<template>
  <div class="block">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><a href="/">Домой</a></li>
        <li><router-link :to="{name: 'root'}">Новости</router-link></li>
        <li class="is-active"><a class="has-text-white">{{ article.title }}</a></li>
      </ul>
    </nav>

    <div class="card">
      <div class="card-content">
        <p class="title">{{ article.title }}</p>
        <p v-html="article.intro"></p>
        <p v-html="article.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import NewsService from '../../services/NewsService'

  export default {
  data() {
    return {
      article: {}
    }
  },
  mounted() {
    this.loadArticle()
  },
  methods: {
    async loadArticle() {
      let resp = false
      resp = await NewsService.getArticle(this.$route.params.id)
      this.article = resp.data
    }
  },
}
</script>

<style scoped>
  .card {
    margin-bottom: 10px;
    background-color: #ffffff;
    opacity: 0.6;
  }
  .card-content {
    color: #000000;
  }
</style>
